import { ICardProductFormMeta } from "./cardProductFormMeta";
import * as yup from "yup";
import { BankIDInputMeta, CorporateNameInputMeta } from "@Shared/containers/form/commonMeta";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";

export interface ICardProgramFormMeta {
    bankId: FormInputMeta;
    bank: FormInputMeta;
    id: FormInputMeta;
    name: FormInputMeta;
    primaryBIN: FormInputMeta;
    cardType: FormInputMeta;
    onlineIssuerRisk: FormInputMeta;
    renewableAuto: FormInputMeta;
    lifeCycle: FormInputMeta;
    creationWithGenerationPin: FormInputMeta;
    withCardActivation: FormInputMeta;
    chipCard: FormInputMeta;
    preparationDate: FormInputMeta;
    renewableWithGenerationPin: FormInputMeta;
}

const cardProgramFormMeta = {} as ICardProgramFormMeta;

cardProgramFormMeta.bankId = {...BankIDInputMeta, name: 'bankId'};

cardProgramFormMeta.bank = {
  ...CorporateNameInputMeta,
  name: "bank",
  label: "Banque",
};

cardProgramFormMeta.id = {
    name: "id",
    type: "text",
    label: "ID",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

cardProgramFormMeta.name = {
    name: "name",
    type: "text",
    label: "Nom",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

cardProgramFormMeta.primaryBIN = {
    name: "primaryBIN",
    type: "number",
    label: "BIN Primaire",
    placeholder: "",
    validation: yup.number().required("Champ obligatoire !")
};

cardProgramFormMeta.cardType = {
    name: "cardType",
    type: "select",
    label: "Type Carte",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

cardProgramFormMeta.onlineIssuerRisk = {
    name: "onlineIssuerRisk",
    type: "select",
    label: "Risque En-ligne Émetteur",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

cardProgramFormMeta.lifeCycle = {
    name: "lifeCycle",
    type: "number",
    label: "Cycle Vie (en Année)",
    placeholder: "",
    validation: yup.number().required("Champ obligatoire !")
};

cardProgramFormMeta.preparationDate = {
    name: "preparationDate",
    type: "number",
    label: "Date Prépartion (en Jour)",
    placeholder: "",
    validation: yup.number().required("Champ obligatoire !")
};

cardProgramFormMeta.renewableAuto = {
    name: "renewableAuto",
    type: "checkbox",
    label: "Renouvelable Auto.",
    placeholder: "",
    validation: yup.boolean()
};

cardProgramFormMeta.creationWithGenerationPin = {
    name: "creationWithGenerationPin",
    type: "checkbox",
    label: "Création avec Génération PIN",
    placeholder: "",
    validation: yup.boolean()
};

cardProgramFormMeta.withCardActivation = {
    name: "withCardActivation",
    type: "checkbox",
    label: "Avec Activation Carte",
    placeholder: "",
    validation: yup.boolean()
};

cardProgramFormMeta.chipCard = {
    name: "chipCard",
    type: "checkbox",
    label: "Carte à Puce",
    placeholder: "",
    validation: yup.boolean()
};

cardProgramFormMeta.renewableWithGenerationPin = {
    name: "renewableWithGenerationPin",
    type: "checkbox",
    label: "Renouv. avec Génération PIN",
    placeholder: "",
    validation: yup.boolean()
};

export default cardProgramFormMeta;
